import React, { Dispatch, useMemo, useRef } from "react";
import useForceUpdate from "../effect/useForceUpdate";

export type Update<S> = S | ((prev: S) => S);
export default function useGetSet<S>(
  initialState: S | undefined = undefined,
  onChange?: (newState: S, prevState: S) => void,
): [get: () => S, set: Dispatch<S>] {
  const state = React.useRef<S>(initialState as any);
  const forceUpdate = useForceUpdate();
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  return useMemo(() => {
    return [
      () => state.current as S,
      (value: Update<S>) => {
        const onChange = onChangeRef.current;
        const nextState: S =
          typeof value === 'function' ? (value as any)(state.current) : value;
        if (nextState !== state.current) {
          onChange?.(nextState, state.current);
        }
        state.current = nextState;
        forceUpdate();
      },
    ];
  }, [forceUpdate]);
}
